export default __webpack_public_path__ + "static/media/krystal.e46c25a2.png";